// src/components/JobView/Tabs/GeneralInfoDisplayTab.js

import React from 'react';
import { suggestSheets } from '../../../lib/gangrun';

const GeneralInfoDisplayTab = ({ jobData, clients, setMaximizedImageUrl }) => {
  // Caso Gang Run: no tiene un solo cliente; mostramos material/pliego/clientes.
  if (jobData.type === 'GangRun') {
    const lines = jobData.gangLines || [];
    const clientsN = new Set(lines.map(l => l.clientId).filter(Boolean)).size;
    const gangFields = [
      { label: 'Nombre', value: jobData.jobName },
      { label: 'Material', value: jobData.materialName || 'N/A' },
      { label: 'Hoja', value: `${jobData.sheet?.width || '?'} × ${jobData.sheet?.height || '?'} ${jobData.sheet?.unit || ''}` },
      { label: 'Hojas a correr', value: String(suggestSheets(lines)) },
      { label: 'Clientes en la hoja', value: String(clientsN) },
      { label: 'Líneas (SKU)', value: String(lines.length) },
    ];
    return (
      <div className="space-y-6 p-4">
        <div className="inline-flex items-center gap-2 text-sm font-semibold px-3 py-1 rounded-full bg-fuchsia-100 text-fuchsia-700">Gang Run / Combo</div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-4">
          {gangFields.map(f => (
            <div key={f.label}><p className="text-sm font-bold text-gray-600">{f.label}</p><p className="mt-1 text-gray-900">{f.value || 'N/A'}</p></div>
          ))}
        </div>
        <p className="text-sm text-gray-500">El detalle de piezas (cliente + SKU + ups) está en la pestaña <b>Detalles</b>.</p>
      </div>
    );
  }

  // Se añade una comprobación para asegurar que 'clients' no sea undefined
  const clientName = (clients || []).find(c => c.id === jobData.clientId)?.name || 'N/A';

  const fields = [
    { label: 'Cliente', value: clientName },
    { label: 'Nombre del Trabajo', value: jobData.jobName },
    { label: 'Fecha de Entrega', value: jobData.deliveryDate },
    { label: 'Orden de Venta (ERP)', value: jobData.salesOrder },
    { label: 'Orden de Compra (PO)', value: jobData.purchaseOrder },
    { label: 'Descripción', value: jobData.description },
  ];

  return (
    <div className="space-y-8 p-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-2 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
            {fields.map(field => (
              <div key={field.label}>
                <p className="text-sm font-bold text-gray-600">{field.label}</p>
                <p className="mt-1 text-gray-900 whitespace-pre-wrap">{field.value || 'N/A'}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="md:col-span-1">
          <p className="text-sm font-bold text-gray-600 block mb-2">Imagen Principal</p>
          <div className="w-full h-64 flex items-center justify-center border rounded-lg bg-gray-50">
            {jobData.coverImageUrl ? 
              <img 
                src={jobData.coverImageUrl} 
                alt="Imagen del producto" 
                className="max-h-full max-w-full object-contain rounded-lg cursor-pointer hover:opacity-80 transition-opacity"
                onClick={() => setMaximizedImageUrl(jobData.coverImageUrl)}
              />
              :
              <p className="text-gray-400 text-sm">Sin imagen</p>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralInfoDisplayTab;

